<template>
    <div class="dm-prizes-and-grants">
        <div class="mb-4">
            <div
                class="mb-4 dm-prize"
                v-for="(prize, index) in prizes_and_grants"
                :key="'prize-' + index"
            >
                <input
                    type="text"
                    class="form-control"
                    :class="'dm-prize-field-' + index"
                    v-model="prizes_and_grants[index]"
                    @change="$emit('prizesUpdated')"
                />
                <button
                    class="btn btn-xs btn-icon btn-light-danger"
                    @click="remove(index)"
                >
                    <i class="icon-sm las la-times"></i>
                </button>
            </div>
        </div>

        <button
            class="btn btn-success dm-add-new-prize dm-btn-wizard"
            @click="addNew()"
        >
            {{ translate("Add") }}
        </button>
    </div>
</template>

<script>
export default {
    components: {},

    props: ["prizes_and_grants"],

    methods: {
        addNew() {
            this.prizes_and_grants.push("");
        },
        remove(index) {
            this.prizes_and_grants.splice(index, 1);
            this.$emit("prizesUpdated");
        },
    },
};
</script>
